import WallCommon from "./wallCommon";

export default class CeilingPanels extends WallCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'ceiling_panels';
    this.partName = 'Ceiling Panels';
    this.translateId = "visualizer.bathroom.ceiling_panels";
    this.isStoneFeature = true;
  }
}
